import { storageKey } from '~/constants/storage';

// Auth storage keys, route paths, and query-param names. Centralized so
// writers and readers can't drift on string literals. Bump the trailing
// `:v<n>` on any storage key whose wire/serialized shape breaks.
export const STORAGE_KEYS = {
	lastLoginMethod: storageKey('last-login-method'),
	pendingLoginMethod: storageKey('pending-login-method'),
	ssoLoginReturnTo: storageKey('sso-login-return-to'),
	ssoLinkReturnTo: storageKey('sso-link-return-to'),
	ssoSignupContext: storageKey('sso-signup-context'),
	loginProvidersCache: storageKey('login-providers-cache:v1'),
} as const;

export const AUTH_ROUTES = {
	callback: '/auth/callback',
	login: '/auth/login',
} as const;

// Shared between the wizard / edit dialog's `<DForm>` and the external
// submit button's `form="..."` attribute.
export const AUTH_PROVIDER_FORM_ID = 'auth-provider-form';

// Shared by readers and writers so a typo can't silently break the auth
// round-trip's link/login flow.
export const QUERY_PARAMS = {
	linkSuccess: 'linkSuccess',
	linkError: 'linkError',
	provider: 'provider',
	step: 'step',
	reason: 'reason',
	redirect: 'redirect',
	email: 'email',
} as const;

/** Non-SSO login method id — persisted by useLastLoginMethod and matched in the chooser. */
export const EMAIL_LOGIN_METHOD = 'email';
